import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import ProductsPage from '../../Components/ProductsPage/ProductsPage';
import InstallAppButton from '../../Components/InstallApp/InstallAppButton';
import './PageProductos.css';

export default function PageProductos() {
    const navigate = useNavigate();

    return (
        <main className='catalogCompactPage'>
            <header className='catalogCompactHeader'>
                <button
                    type='button'
                    className='catalogCompactHeader__back'
                    onClick={() => navigate(-1)}
                    aria-label='Volver a la página anterior'
                >
                    <FontAwesomeIcon icon={faArrowLeft} aria-hidden='true' />
                </button>
                <h1>Productos</h1>
                <InstallAppButton variant='catalog' />
            </header>

            <ProductsPage />
        </main>
    );
}
